import { Injectable, Type } from '@angular/core';
import { TrustpilotComponent } from '../components/trustpilot/trustpilot.component';
import { DemosComponent } from '../components/demos/demos.component';
import { SpeedComponent } from '../components/speed/speed.component';
import { SeoComponent } from '../components/seo/seo.component';
import { ComparaisonComponent } from '../components/comparaison/comparaison.component';
import { ConversionComponent } from '../components/conversion/conversion.component';
import { UpsellComponent } from '../components/upsell/upsell.component';
import { ApplicationsComponent } from '../components/applications/applications.component';
import { CustomerServiceComponent } from '../components/customer-service/customer-service.component';
import { ProductsHomeComponent } from '../components/products-home/products-home.component';
import { SocialsComponent } from '../components/socials/socials.component';

@Injectable({
  providedIn: 'root',
})
export class ComponentMapperService {
  private mappings: { [key: string]: Type<any> } = {
    trustpilot: TrustpilotComponent,
    demos: DemosComponent,
    speed: SpeedComponent,
    seo: SeoComponent,
    comparaison: ComparaisonComponent,
    conversion: ConversionComponent,
    upsell: UpsellComponent,
    applications: ApplicationsComponent,
    'customer-service': CustomerServiceComponent,
    'products-home': ProductsHomeComponent,
    socials: SocialsComponent,
  };

  getComponent(typeName: string): Type<any> {
    return this.mappings[typeName];
  }
}
